import { css } from "@emotion/react";
import styled from "@emotion/styled";
import ArrowDown from "@engineering/icons/arrow-down";
import { complement, darken, desaturate, lighten } from "polished";
var ScreenReaderOnly = /*#__PURE__*/ css("position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0;");
var ScreenReaderOnlyDiv = /*#__PURE__*/ styled("div", {
    target: "e1pu54op0"
})(ScreenReaderOnly);
var ScreenReaderOnlyLabel = /*#__PURE__*/ styled("label", {
    target: "e1pu54op1"
})(ScreenReaderOnly);
var SpanWrapper = /*#__PURE__*/ styled("span", {
    target: "e1pu54op2"
})("color:", function(param) {
    var disabled = param.disabled, theme = param.theme;
    return disabled ? lighten(0.19, desaturate(0.92, complement(theme.color.primary70))) : darken(0.46, desaturate(0.32, theme.color.primaryHighlight));
}, ";position:relative;display:flex;align-items:center;justify-content:center;column-gap:0.25rem;");
var IconSpan = /*#__PURE__*/ styled("span", {
    target: "e1pu54op3"
})("pointer-events:none;position:absolute;left:0.5rem;display:flex;height:1rem;width:1rem;overflow:hidden;fill:currentcolor;");
var Select = /*#__PURE__*/ styled("select", {
    target: "e1pu54op4"
})("width:100%;cursor:pointer;appearance:none;border-radius:", function(param) {
    var compact = param.compact, theme = param.theme;
    return compact ? theme.borderRadius.sm : theme.borderRadius.md;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";padding:", function(param) {
    var compact = param.compact, theme = param.theme;
    return compact ? theme.spacing[20] : theme.spacing[40];
}, ";padding-left:", function(param) {
    var icon = param.icon;
    return icon && "2rem";
}, ";padding-right:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";border:", function(param) {
    var compact = param.compact, disabled = param.disabled, theme = param.theme;
    if (compact) {
        return 0;
    }
    var color = disabled ? theme.color.natural20 : theme.color.natural40;
    return "1px solid ".concat(color);
}, ";color:", function(param) {
    var disabled = param.disabled, theme = param.theme;
    return disabled ? theme.color.natural30 : "currentcolor";
}, ";&:focus{background-color:", function(param) {
    var compact = param.compact, theme = param.theme;
    return compact ? lighten(0.065, desaturate(0.25, theme.color.primaryHighlight)) : "initial";
}, ";outline-color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";border:", function(param) {
    var compact = param.compact, theme = param.theme;
    return compact ? "initial" : "2px solid ".concat(theme.color.primary70);
}, ";margin:", function(param) {
    var compact = param.compact;
    return compact ? "initial" : "-1px";
}, ";}&:hover{&:not([disabled]){background-color:", function(param) {
    var compact = param.compact, theme = param.theme;
    return compact ? lighten(0.065, desaturate(0.25, theme.color.primaryHighlight)) : "initial";
}, ";border:", function(param) {
    var compact = param.compact, theme = param.theme;
    return compact ? "initial" : "2px solid ".concat(theme.color.primary70);
}, ";margin:", function(param) {
    var compact = param.compact;
    return compact ? "initial" : "-1px";
}, ";}}");
var StyledArrowDown = /*#__PURE__*/ styled(ArrowDown, {
    target: "e1pu54op5"
})("height:0.75rem;width:0.75rem;pointer-events:none;position:absolute;right:0.5rem;right:8px;");
var StyledLabel = /*#__PURE__*/ styled("label", {
    target: "e1pu54op6"
})("position:absolute;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.color.natural40;
}, ";display:block;left:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";top:-8px;font-size:0.75rem;line-height:1.5;margin:0;overflow:hidden;pointer-events:none;text-overflow:ellipsis;white-space:nowrap;z-index:2;padding:", function(param) {
    var theme = param.theme;
    return "0 ".concat(theme.spacing[20]);
}, ";&:empty ~ select{padding-top:0.1875rem;padding-bottom:0.1875rem;}");
var Hint = /*#__PURE__*/ styled("div", {
    target: "e1pu54op7"
})("padding-left:", function(param) {
    var theme = param.theme;
    return theme.spacing[30];
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.color.natural30;
}, ";font-size:", function(param) {
    var theme = param.theme;
    return theme.fontSize.xxs.size;
}, ";");
export { Hint, ScreenReaderOnlyDiv, ScreenReaderOnlyLabel, SpanWrapper, IconSpan, Select, StyledArrowDown, StyledLabel };
